import React from "react";
import firebase from "firebase/app";
import "firebase/database";
import moment from "moment";

export default class ErrorBoundary extends React.Component {
	constructor(props) {
		super(props);
		this.state = { hasError: false };
	}

	static getDerivedStateFromError(error) {
		// Update state so the next render will show the fallback UI.
		return { hasError: true };
	}

	componentDidCatch(error, info) {
		// You can also log the error to an error reporting service
		firebase
			.database()
			.ref("errors")
			.push({
				issue: "System error",
				data: {
					error: error,
					info: info,
					system: navigator.userAgent,
					time: moment().format()
				}
			});
		// logErrorToMyService(error, info);
	}

	render() {
		if (this.state.hasError) {
			// You can render any custom fallback UI
			return (
				<React.Fragment>
					<h1>
						Something went wrong, we recieved an error log and working to fix
						it.
					</h1>
					<h1>Please try again later.</h1>
				</React.Fragment>
			);
		}

		return this.props.children;
	}
}
